function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function') && !Array.isArray(value);
}
function isFunction(value) {
  return typeof value === 'function';
}
function isTheme(value) {
  return value === null || value === void 0 ? void 0 : value.theme;
}
const num = n => typeof n === 'number' && !Number.isNaN(n);
const unit = unit => value => num(value) && value !== 0 ? `${value}${unit}` : value;
const px = unit('px');
const getBreakpointMin = (breakpoints, key) => {
  const value = breakpoints[key];
  return value === 0 ? null : px(value);
};
function createMediaQuery(value) {
  return value ? `@media (min-width: ${value})` : null;
}
const getMedias = breakpoints => {
  const medias = {};
  // eslint-disable-next-line guard-for-in
  for (const value in breakpoints) {
    // @ts-ignore
    medias[value] = createMediaQuery(getBreakpointMin(breakpoints, value));
  }
  return medias;
};
const defaultBreakpoints = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
};

export { createMediaQuery, defaultBreakpoints, getBreakpointMin, getMedias, isFunction, isNumber, isObject, isTheme, num, px, unit };
